import { Ciap, Cid10, SituacaoProblema } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { Problema } from '../../../../aside/types/ProblemaModel'
import { ProblemaCondicaoModel } from '../model-problemasCondicoes'

export function hasProblemaDuplicado(
  form: ProblemaCondicaoModel,
  values: ProblemaCondicaoModel[],
  isEdit: boolean,
  somenteCiap: boolean
): boolean {
  return values.some(
    (problema) =>
      isCiapOuCidDuplicado(form, problema, somenteCiap, isEdit) &&
      !(problema.isRegistradoAgora && problema.situacaoProblema === SituacaoProblema.RESOLVIDO)
  )
}

export function hasProblemaDuplicadoLPC(
  form: ProblemaCondicaoModel,
  values: ProblemaCondicaoModel[],
  isEdit: boolean,
  somenteCiap: boolean
): boolean {
  return values.some(
    (problema) =>
      isCiapOuCidDuplicado(form, problema, somenteCiap, isEdit) &&
      problema.situacaoProblema !== SituacaoProblema.RESOLVIDO &&
      form.situacaoProblema !== SituacaoProblema.RESOLVIDO
  )
}

export function isCiapOuCidDuplicado(
  problemaAdicionado: ProblemaCondicaoModel,
  problemaExistente: ProblemaCondicaoModel,
  somenteCiap: boolean,
  isEdit: boolean
): boolean {
  return (
    problemaAdicionado?.ciap?.id === problemaExistente.ciap?.id &&
    ((somenteCiap && !problemaAdicionado.cid?.id && !problemaExistente.cid?.id) ||
      problemaAdicionado?.cid?.id === problemaExistente.cid?.id) &&
    (!isEdit || problemaAdicionado._id !== problemaExistente._id)
  )
}

export function hasProblemaDuplicadoEmAtivosLatentes(
  form: ProblemaCondicaoModel,
  problemasAtivosLatentes: ReadonlyArray<Problema>,
  checkIfParAtualIsResolvido: boolean
): boolean {
  return problemasAtivosLatentes.some(
    (problema) =>
      problema.ciap?.id === form.ciap?.id &&
      problema.cid10?.id === form.cid?.id &&
      problema.situacao !== SituacaoProblema.RESOLVIDO &&
      (checkIfParAtualIsResolvido ? form.situacaoProblema !== SituacaoProblema.RESOLVIDO : true)
  )
}

export const isEvolucao = (problemaCondicao?: ProblemaCondicaoModel): boolean =>
  !isUndefinedOrNull(problemaCondicao?.problemaCondicaoEvoluir)

export const isAutomatico = (problemaCondicao: ProblemaCondicaoModel): boolean => problemaCondicao.isAutomatico === true

export function isProblemaCondicaoInCiapCidList(
  problemaCondicao: ProblemaCondicaoModel,
  ciaps?: Ciap[],
  cids?: Cid10[]
) {
  return (
    ciaps?.some((ciap) => ciap?.codigo === problemaCondicao?.ciap?.codigo) ||
    cids?.some((cid) => cid?.codigo === problemaCondicao?.cid?.codigo)
  )
}
